import cn from 'classnames';
import { AutoScroll } from 'components/blocks/AutoScroll';
import { NextLinkTr } from 'components/blocks/NextLink';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { BlockHeader } from 'components/blocks/BlockHeader';
import { BlockContent } from 'components/blocks/BlockContent';
import { BoxWithShadow } from 'components/blocks/BoxWithShadow';
import { Routes } from 'routes';
import { IResortPathInfo, ISnowHistoryItem } from 'api/resort/types';
import {
  SnowItemChart, SnowItemData, SnowItemTh,
} from 'components/resort/RecentSnowfall/SnowItem';
import { SnowUnit } from 'components/blocks/Unit';
import { isMainLocale } from 'util/i18nFlags';

import styles from './styles.module.scss';

interface IRecentSnowfallProps {
  resort: IResortPathInfo,
  isFresh: boolean,
  data: Array<ISnowHistoryItem>,
  isMetricUnits: boolean
}

export const RecentSnowfall = ({
  resort, isFresh, data, isMetricUnits,
}: IRecentSnowfallProps) => {
  const { t } = useOTSTranslation('common');
  const max = data.reduce((val, item) => Math.max(item.snow, val), 20);
  const sum = data.reduce((val, item) => item.snow + val, 0);

  return (
    <BoxWithShadow>
      <BlockHeader title={t('resort.skiReport.recentSnowfall')}>
        {isMainLocale() && (
          <NextLinkTr href={Routes.resortSnowfall(resort)} scroll>
            {t('resort.skiReport.historicalSnowfall')}
          </NextLinkTr>
        )}
      </BlockHeader>
      <BlockContent blur={!isFresh}>
        <div className={styles.last7}>
          <h3 className={styles.label}>{t('resort.skiReport.last7Days')}</h3>
          <div className={styles.value}>
            <div className={styles.bar} />
            <div className={cn(styles.text, { [styles.metric]: isMetricUnits })}>
              <SnowUnit values={sum} />
            </div>
          </div>
        </div>
        <AutoScroll>
          <table className={styles.snowList}>
            <tbody>
              <tr>
                {data.map((d) => (
                  <SnowItemData
                    key={d.date}
                    snow={d.snow}
                    date={d.date}
                    height={d.snow / max}
                    hasSnowFlake={d.snow === max}
                  />
                ))}
              </tr>
              <tr>
                {data.map((d) => <SnowItemTh key={d.date} snow={d.snow} date={d.date} height={d.snow / max} hasSnowFlake={d.snow === max} />)}
              </tr>
              <tr>
                {data.map((d) => <SnowItemChart key={d.date} snow={d.snow} date={d.date} height={d.snow / max} hasSnowFlake={d.snow === max} />)}
              </tr>
            </tbody>
          </table>
        </AutoScroll>
      </BlockContent>
    </BoxWithShadow>
  );
};
